import Oidc from "./oidc"

let managerInstance = null

let onConfiguredCallback = null
let onConfiguredPromise = null

if (process.env.NODE_ENV === "production") {
  Oidc.Log.logger = console;
  Oidc.Log.level = Oidc.Log.INFO;
} else {
  Oidc.Log.logger = console;
  Oidc.Log.level = Oidc.Log.DEBUG;
}

export const configure = (authority, clientId, scope) => {
  managerInstance = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: authority,
    client_id: clientId,
    redirect_uri: window.location.origin + "/signin-callback",
    response_type: "code",
    response_mode: "query",
    scope: scope,
    post_logout_redirect_uri: window.location.origin + "/signout-callback",
    silent_redirect_uri: window.location.origin + "/static/oidc-silent-renew.html",
    popup_redirect_uri: window.location.origin + "/static/oidc-popup-callback.html",
    popupWindowFeatures: "location=no,toolbar=no,width=520,height=660,left=300,top=200;",
    monitorSession: false
  });

  if (onConfiguredCallback) {
    onConfiguredCallback(managerInstance)
  }
};

export default {
  get instance() {
    if (!managerInstance) {
      throw new Error("This oidc manager not configured. Call configure method.")
    }

    return managerInstance;
  },

  waitConfigure() {
    if (!onConfiguredPromise) {
      onConfiguredPromise = new Promise(resolve => {
        onConfiguredCallback = resolve
      });
    }

    return onConfiguredPromise
  }
}
